import { useAuth } from "../Context/AuthContext";
import { parseAccessibilityRule } from "../Utils/accessibilityRules";

/**
 * Returns the access level for a given service based on server-evaluated accessibility rules.
 *
 * @param {string} accessKey - e.g. "MY_ORG", "MY_FARM"
 * @returns {{ level: string, limit: number|null }}
 *   level — FULL | READ_ONLY | SUBSCRIBE_REQUIRED | HIDDEN
 *   limit — always null (RESTRICTED, the only level that ever set this, was removed)
 *
 * systemAdmin users always get FULL regardless of rules.
 * Services with no rule in the map default to FULL.
 */
export default function useServiceAccess(accessKey) {
  const { accessibilityRules, normalizedRoles } = useAuth();

  if (normalizedRoles?.systemAdmin) return { level: "FULL", limit: null };
  if (!accessKey) return { level: "FULL", limit: null };

  return parseAccessibilityRule(accessibilityRules?.[accessKey]);
}
